module.exports = __webpack_public_path__ + "fonts/Rubik-300-latin-ext11.15c3dca.woff2";